/**
 * @Page APIDG
 * @Description [APIDG]수신자료관리 - 협력사 정보 연계 - [DG]전주공장간판발주
 **/
 import React, { useState, useEffect, useRef, useCallback  } from "react";
 import Ribbon from '@/components/organisms/Ribbon';
 import ContentXearch from '@/components/organisms/ContentXearch';
 import Content from '@/components/organisms/Content';
 import Grid from '@/components/grid/agGrid';
 import CustomAlert from "@/components/molecules/CustomAlert";
 import AlertDialog from '@/components/material-UI/AlertDialog';
 import * as Common from '@/utils/Common'; 
import CommonUtil from '@/utils/CommonUtil'; 
 import {getToday} from "@/utils/Common";
 import UploadModal from "@/components/organisms/UploadModal";
 import Loading from "src/components/atoms/CustomLoading2";
  
 const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER; 
 const CODES = require('@/config/commonCode.json');
 const Utils = new CommonUtil();

 
  function APIDG() {
 
    const token = Common.getToken();
    const userId = Common.getToken("id");
    const tVnt1 = Common.getToken("vand");
    const tComp = Common.getToken("comp");
    const grdRntc14Main = useRef();
    const [gridApi, setGridApi] = useState(null);
    const ckVnt1 = Common.getCookie("ck_vnt1"+userId)===null||Common.getCookie("ck_vnt1"+userId)===""||Common.getCookie("ck_vnt1"+userId)==="undefined"?tVnt1:Common.getCookie("ck_vnt1"+userId); 
    let [loading, setLoading] = useState(false);
    
      const onGridReady  = (params) => {
        setGridApi(params);
    };
      const [idata, setData] = useState({
        kFpdt: getToday(),
        kTpdt: getToday(),
        kNpdt: Common.getToday(), //납품일자
        kVnt1: ckVnt1,
        kPlnt: "",          //공장
        kComp : tComp,
        kDocd : "",
        kTotcnt : "",
        kVnt1Nm : "",
        kCompNm : tComp==="EHMC"?"현대자동차(주)":"기아자동차(주)",
        kPageNum: 1,
        kPageTotal: 0,
        
        vnt1List : [],
        docdList : [],
    }); 
    
    const [message, setMessage] = React.useState( {
        openAlert : false,      
        severity : "success",   
        msg : ""                
    });
    const { openAlert, severity, msg } = message;
    const [uploadInfo, setUploadInfo] = useState({ vnt1: tVnt1, subDir: "DATA" });

    const [panded, setPanded] = React.useState(true);
    const [style, setStyle] = useState({ height :"calc(100vh - 60px - 50px - 55px  - 50px)"});
    const [dlgMessage, setDlgMessage] = React.useState( {
        openDlg : false,    
        dlgTrans : "",      
        dlgMsg : ""         
    });
    const { openDlg, dlgTrans, dlgMsg } = dlgMessage;
  
    let [searchApi, setSearchApi] = useState(false); 
    const [openUpload, setOpenUpload] = React.useState(false);

    const onClearApi = useCallback(async (e) => {
        setSearchApi(false);

    }, []);


    /**
     * 공통코드 조회 (조회조건)
     */
    const onSearchCommon = (para, name) => {
		let commonData = idata;

		const fetchData = async (para, name) => {
			let param = encodeURIComponent(para);
			const query = SERVER_URL + '/comcd/search?query=' + param;
			await fetch(query, { headers: { Authorization: token } })
				.then((resp) => resp.json())
				.then((data) => {
					if (data.success) {
						if (name === 'plntList') {
							if (data.data.length > 0) {
								commonData['kPlnt'] = data.data[0].comCode;
								commonData['kPlntNm'] = data.data[0].text;
							}
						}
						commonData[name] = data.data;
						setData({ ...commonData });
					}
				});
		};
		fetchData(para, name);
	};

    const onSearchCommon1 = (para, name) => {
        let commonData = idata;

        const fetchData = async (para, name) => {
            let param = encodeURI(para);
            const query = SERVER_URL + "/comcd/search?query=" + param; 
            await fetch(query, { headers: { Authorization: token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) 
                    { 
                    commonData[name] = data.data[0].text;
                    setData({...commonData});
                    }
                })
        }
        fetchData(para, name);   
    }

    useEffect( () => {
        //공통코드 (T1업체)
        onSearchCommon(`{"pgmid":"VNT1"}`, "vnt1List");
        onSearchCommon1(`{"pgmid":"WRCVAND","kVnt1":"${idata.kVnt1}"}`, "kVnt1Nm");
        onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}", "kGubn":"VMI"}`, "plntList");
    }, []);

    /**
     * Control 변경 Event
     * @param {*} e 
     */
    const onChange = async (e) => {
        const { name, value, desc } = e.target;

        let newSearchs = idata; 
        let newUploadInfo = uploadInfo;
        newSearchs[name] = value;
        newSearchs[name+"Nm"] = desc;
        
        setData({ ...newSearchs });

        if (name === "kVnt1")  {
            newSearchs["kDocd"] = "";
            newSearchs["kPageNum"] = 1;
            newUploadInfo["vnt1"] = value;

            setData({ ...newSearchs });
            setUploadInfo({ ...newUploadInfo });

            onSearchCommon(`{"pgmid":"CONS_SALE","Key1":"*", "kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}"}`, "docdList");
        }
        if(name==="kComp"){
            newSearchs["kCompNm"] = value==="EHMC"?"현대자동차(주)":"기아자동차(주)";
            newSearchs["kDocd"] = "";
            setData({ ...newSearchs });

            onSearchCommon(`{"pgmid":"CONS_SALE","Key1":"*", "kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}"}`, "docdList");
        }
         if( name === "kDocd"){
            newSearchs["kPageNum"] = 1;
            setData({ ...newSearchs });
        }


        onSearch()
    }

    /**
     * Grid Event 
     * @param {*} e 
     */
    const grdRntc14Main_onCellValueChanged = async (e) => {
    }
    const grdRntc14Main_onRowClicked = async (e) => {
    }

    /**
     * 검색조건
     */
    const optionsX = {
        0: [
            //T1업체
            {
                formatter: "select", name: "kVnt1", labelName: "T1업체", type: "text", defaultValue: idata.kVnt1,  
                codeMode: true,
                selectAll: "", // selectAll :: 전체 option 표출 여부 :: { "comCode" : "" , "text" : "전체" }
                codes: null,
                comms: idata.vnt1List, 
                align: "left", 
            },
            // 공장
            {
                formatter: "select", name: "kPlnt", labelName: "공장", type: "text", defaultValue: idata.kPlnt,  
                codeMode: false,
                selectAll: "all", // selectAll :: 전체 option 표출 여부 :: { "comCode" : "" , "text" : "전체" }
                codes: null,
                comms: idata.plntList,
                align: "left", 
            },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" }
        ],
        1: [
            //납품일자
             {
                "formatter": "input", "name": "kNpdt", "labelName": "납품일자", "type": "date", "desc": "", "readOnly" : false,
                "defaultValue": idata.kNpdt,  
                "align": "left", 
                "labelType": "none" 
            }, 
            // 입고일자
            {
                formatter: "date2", name: "kFpdt",name2: "kTpdt", labelName: "From 생성일", type: "date",
                defaultValue: idata.kFpdt, defaultValue2: idata.kTpdt,
                codeMode: false,
                selectAll: "", // selectAll :: 전체 option 표출 여부 :: { "comCode" : "" , "text" : "전체" }
                codes: null,
                comms: null,
                align: "left", 
            },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" }
        ]
    }

    /**
     * 조회 
     * @param {*} e 
     * @returns 
     */
    const onSearch = async (e) => {

        //T1업체선택 Check
        if (idata.kVnt1 == "")
        {
            setMessage({ openAlert : true, 
                        severity : "info",
                        msg : "1차업체를 선택하십시요 !"});
            document.getElementById("kVnt1").focus();                         
            return ;
        }

        //회사구분선택 Check
        if (idata.kComp == "")
        {
            setMessage({ openAlert : true, 
                         severity : "info",
                         msg : "회사구분을 선택하십시요 !"});
            document.getElementById("kComp").focus();                         
            return ;
        }

        // Cookie 값 셋팅
        Common.setCookie("ck_vnt1"+userId,idata.kVnt1,1);

        const page = "INF_CONS_SALE_STAT"
        let para = `{
                        "kGubn":"${page}",
                        "kVnt1": "${idata.kVnt1}", "docd": "${idata.kDocd}", "kComp": "${idata.kComp}","kPtno":"${idata.kPtno}",
                        "kPageNum":"${idata.kPageNum}"
                    }`;
        let param = encodeURI(para);

        const query = SERVER_URL + "/AutoReceiver/WeeklyMaterialReq/search?query=" + param;
        setSearchApi(query);
    }

    /**
    * 파일생성
    * @param {*} e 
    */
    const onUpload = async (e) => {
        let newSearchs = idata; 

        newSearchs["vnt1"] = idata.kWrcVand;
        setData({ ...newSearchs });

        setOpenUpload(true);
    }

    const handleUploadClickOpen = () => {

    setOpenUpload(true);
    };

    const handleUploadClose = () => {
    setOpenUpload(false);

    };

    /**
     * 엑셀
     * @param {*} e 
     */
    const onExcel = async (e) => {
        const page = "WEEK_MATE"
        let para = `{"kDocument":"주별소요량",
                     "kGubn":"${page}","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}","kDocd":"${idata.kDocd}",
                     "vnt1Nm":"${idata.kVnt1Nm}","compNm":"${idata.kCompNm}","docdNm":"${idata.kDocd===""?"전체":idata.kDocd}","kTotcnt": "${idata.kTotcnt}"}`;
        
        let param = encodeURIComponent(para);
        const query = SERVER_URL + "/AutoReceiver/excel?query=" + param;
        setLoading(true);
        await fetch(query, {headers: {Authorization: token } })
            .then((resp) =>{
                return resp.blob();
            }).then((blob)=>{
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', '주별소요량.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'error', err });
            })
        setLoading(false);

        // 엑셀파일 생성 메세지
        setMessage({ openAlert : true, 
                    severity : "success",
                    msg : "엑셀파일이 생성되었습니다."});
        
    }
    
    //Transaction AlertDialogResult
    const AlertDialogResult = async (e) => {

        //AlertDialog 초기화
        setDlgMessage({ openDlg : false,  dlgTrans : "", dlgMsg : ""});

        //DialogResult
        if (e.result == "N") return;

        //Transaction 구분
        switch (e.Trans) 
        {
            //등록
            case "I" :
                break;
            //수정
            case "U" :
                break;
            //삭제
            case "D" :
                break;

            case "D3" :
                break;
        }
    }
        
    //조회건수
    const onSetCount = (e) => {
        let cnt;
        if(gridApi.api.rowRenderer.gridApi.rowModel.rowsToDisplay.length > 0){
            cnt = gridApi.api.rowRenderer.gridApi.rowModel.rowsToDisplay[0].data.cnt;
        }else{
            cnt = 0;
        }
        let newSearchs = idata; 

        if(idata.kPageNum === 1){
            newSearchs["kPageTotal"] = Math.ceil(parseInt(cnt)/500);
            newSearchs["kTotcnt"] = Common.getNumberFormatter(cnt);
            setData({ ...newSearchs });
        }   
    }
        
    /**
     *Grid Column 정의 
    */
     const columnDefs = [
        { headerName: "구매 문서 번호", field: "EBELN", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "구매 문서의 항목 번호", field: "EBELP", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "업체번호", field: "LIFNR", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "공장", field: "WERKS", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "품번", field: "MATNR", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "내역", field: "TXZ01", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "레코드 생성일 ", field: "ERDAT", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "오더 유형(구매)", field: "BSART", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "수량", field: "MENGE", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "기본 단위", field: "MEINS", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "단가 I/F", field: "NETPR", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "통화 키", field: "WAERS", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "품목 납품일", field: "EINDT", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "납입지시 구분", field: "ZCCYCGN", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "납입지시시간", field: "ZTCYTIM", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "수작업발주여부", field: "ZCHDPOGB", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "공장별 게이트", field: "ZCPGATE", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "피더코드", field: "ZCFDR", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "납품 완료 지시자", field: "ELIKZ", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
    ];

    const onClick = async (e) => {
        setPanded(!panded);

        if(panded===true){
            setStyle({       
                height :"calc(100vh - 60px - 50px - 50px)"
            });
        }else{
            setStyle({
                height :"calc(100vh - 60px - 50px - 55px  - 50px)"
            });
        }
    }
    return(
        <>
            <AlertDialog open={openDlg}  trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

            <CustomAlert open={openAlert} severity={severity} duration={3000} message={msg} onClose={()=> {setMessage({openAlert:false, severity:"", msg:"조회 실패"})}} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />

            <UploadModal
                open={openUpload}
                onClose={handleUploadClose} 
                onClickOpen={handleUploadClickOpen}
                title={"CSV 업로드"}
                fileId={"APIDG"}
                filePath={"C:\\HKC\\VAN\\APIDG.CSV"}
                uploadInfo={uploadInfo}
                accp=".csv"
                maxFiles={1}
                validatorName={"csv"}
                uploadApi={SERVER_URL + "/erp/upload1"}
                data={idata.vnt1List}
            />
            <Loading loading={loading} />

            <Ribbon
                onSearch={onSearch} onSearchName={null} //조회
                //onExcel={onExcel} onExcelName ={null}   //Excel
                // onUpload={onUpload} onUploadName={"생성"}//생성 
                onExcel={onExcel} onExcelName ={null}   //Excel
            >
                {"수신자료관리 > API수신정보확인 > "}<b style={{ color: "#cd5c5c", fontFamily: "PretendardLight, NanumGothic, sans-serif" }}>[DG]전주공장간판발주</b>
            </Ribbon>


            <ContentXearch
                optionsX={optionsX}
                onChange={onChange}
                onClick={onClick} />


            <Content style={style}> 
                <div className={"grid_type01"} >
                    <div className={"grid_wrap01"}> 
                        <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                            <Grid
                                ref={grdRntc14Main}
                                gridId={"APIDG"}                 
                                columnDefs={columnDefs}           
                                pagination={true}                 
                                paginationCsv={false}             
                                onGridReadyEvent={onGridReady}
                                paginationPageSize={"500"}        
                                rowMultiSelectWithClick={true}    
                                suppressRowClickSelection={true}  
                                rowSelection={"multiple"}         
                                enableRangeSelection={false}      
                                enableCellTextSelection={true}    
                                isFirst={false}                   
                                displayNo = {false}
                                searchApi={searchApi} 
                                onClearApi={()=> {onSetCount();onClearApi()}}
                                onCellValueChangedEvent={grdRntc14Main_onCellValueChanged}
                                onRowClickEvent={grdRntc14Main_onRowClicked}
                            />
                        </div>
                    </div>
                </div>
            </Content>
        </>
    )
  }
  export default APIDG;